import { render, staticRenderFns } from "./AssignAgentDialog.vue?vue&type=template&id=c09d11a2&scoped=true"
import script from "./AssignAgentDialog.vue?vue&type=script&lang=js"
export * from "./AssignAgentDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignAgentDialog.vue?vue&type=style&index=0&id=c09d11a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09d11a2",
  null
  
)

export default component.exports